
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/features/collaborations/jst/edit';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<form action=\"";
  if (helper = helpers.action) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.action); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n      class=\"edit_collaboration communication_message\"\n      method=\"POST\">\n  <input type=\"hidden\" name=\"_method\" value=\"put\" />\n  <input type=\"hidden\" name=\"authenticity_token\" value=\"";
  if (helper = helpers.token) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.token); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n  <div class=\"ic-Form-control\">\n    <label for=\"collaboration_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_title\" class=\"ic-Label\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.labels.document_name", "Document name", options) : helperMissing.call(depth0, "t", "collaborations.edit.labels.document_name", "Document name", options)))
    + "\n      <span aria-hidden=\"true\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.is_required", "This field is required", options) : helperMissing.call(depth0, "t", "collaborations.edit.is_required", "This field is required", options)))
    + "\" class=\"required_symbol\"> *</span>\n    </label>\n    <input id=\"collaboration_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_title\"\n           name=\"collaboration[title]\"\n           aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.labels.title", "Collaboration title", options) : helperMissing.call(depth0, "t", "collaborations.edit.labels.title", "Collaboration title", options)))
    + "\"\n           type=\"text\"\n           class=\"ic-Input labeled-error\"\n           value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n  </div>\n  <div class=\"ic-Form-control\">\n    <label for=\"collaboration_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_description\" class=\"ic-Label\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.labels.description", "Description", options) : helperMissing.call(depth0, "t", "collaborations.edit.labels.description", "Description", options)))
    + "\n    </label>\n    <textarea id=\"collaboration_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_description\"\n              name=\"collaboration[description]\"\n              class=\"ic-Input labeled-error\"\n              >";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n  </div>\n  <div class=\"collaborator_list\"></div>\n\n  <div class=\"collaboration-actions form-actions\">\n    <button type=\"button\" class=\"btn cancel_button\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "collaborations.edit.buttons.cancel", "Cancel", options)))
    + "\n    </button>\n    <button type=\"submit\" class=\"btn btn-primary\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("collaborations.edit")
  },data:data},helper ? helper.call(depth0, "collaborations.edit.buttons.update", "Update collaboration", options) : helperMissing.call(depth0, "t", "collaborations.edit.buttons.update", "Update collaboration", options)))
    + "\n    </button>\n  </div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  